export default "__VITE_ASSET__348f9521__"